const runCreateIterableEmailIdInput = require("./runCreateIterableEmailIdInput");

/**
 * @param emailId {string}
 */
module.exports = function runAppendIterableEmailIdInputToAllForms(emailId) {
  document.querySelectorAll("form").forEach((form) => {
    const input = runCreateIterableEmailIdInput(emailId);
    form.append(input);
  });
};
